<template>
  <div class="page-container" style="width:99%;margin-top:15px;">
        <ul>
          欢迎使用本系统！
        </ul>
  </div>
</template>

<script>
  export default {
    components:{
    },
    methods :{
    }
  }
</script>

<style>
ul{
  text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/views/Home/Index.vue